module.exports = __webpack_public_path__ + "img/krb.32f253ed.svg";